import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AbstractPurchasingService } from '../services/abstract-purchasing.service';
import { PurchaseRequestStatus } from '../enums';

export const purchaseAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const purchasingService = inject(AbstractPurchasingService);
  const router = inject(Router);
  const purchaseId = route.paramMap.get('purchaseId');

  if (!purchaseId) {
    return new RedirectCommand(buildUrlTree(route, router));
  }

  return purchasingService.findPurchaseById(purchaseId).pipe(
    map(response => {
      const purchase = response.body;

      if (!purchase?.status?.includes(PurchaseRequestStatus.ACCEPTED)) {
        return new RedirectCommand(buildUrlTree(route, router));
      }

      purchasingService.setCache(purchaseId, purchase);
      return true;
    }),
    catchError(() => of(new RedirectCommand(buildUrlTree(route, router))))
  );
};

function buildUrlTree(route: ActivatedRouteSnapshot, router: Router): UrlTree {
  const segments = route.pathFromRoot
    .flatMap(r => r.url.map(u => u.path))
    .filter(s => !!s);

  const path = '/' + [...segments.slice(0, -2), 'quadro'].join('/');
  return router.parseUrl(path);
}
